// extracted by mini-css-extract-plugin
export default {"wrapper":"mmKJ6gqIFV","disabled":"_2e25L5MeGe","dot":"QRTO7qQVVU","radio":"_391vOBsmEW","label":"_6v0dIeqsHo"};